<template>
    <IconLoading v-if="isLoadingData" />
    <table class="items-table" v-if="items.length > 0">
        <thead>
            <tr >
                <td></td>
                <td>{{ __("json.ID") }}</td>
                <td>{{ __("json.Article name") }}</td>
                <td>{{ __("json.Quantity") }}</td>
                <td>{{ __("json.Location") }}</td>
                <td>{{ __("json.User") }}</td>
            </tr>
        </thead>
        <tbody>
            <tr class="items-list__item" v-for="item in items" :key="item.id">
                        <td>
                            <a
                                class="button button--outline-red button--sm"
                                @click.prevent="deleteItem(item)"
                            >
                                {{ __("json.Delete") }}
                            </a>
                        </td>
                        <td >
                            <p class="item-card__text item-card__text--ellipsis">
                                {{ item.id }}
                            </p>
                        </td>
                        <td >
                            <p class="item-card__text">{{ item.article_name }}</p>
                        </td>
                        <td >
                            <p class="item-card__text">{{ item.quantity }}</p>
                        </td>
                        <td >
                            <p class="item-card__text">{{ item.location_on_board }}</p>
                        </td>
                        <td >
                            <p class="item-card__text">{{ item.official_use }}</p>
                        </td>
            </tr>
        </tbody>
    </table>
    <!-- <ul class="items-list" v-if="items.length > 0">

        <li class="items-list__item" v-for="item in items" :key="item.id">
            <article class="item-card">
                <div class="item-card__row">
                    <div class="item-card__col item-card__buttons">
                            <a class="button button--red button--sm" @click.prevent="deleteItem(item)">
                                {{ __('json.Delete') }}
                            </a></div>
                    <div class="item-card__col">
                        <h4 class="item-card__title">{{ __("json.ID") }}</h4>
                        <p class="item-card__text item-card__text--ellipsis">{{ item.id }}</p>
                    </div>
                    <div class="item-card__col">
                        <h4 class="item-card__title">{{ __("json.Article name") }}</h4>
                        <p class="item-card__text">{{ item.article_name }}</p>
                    </div>
                    <div class="item-card__col">
                            <h4 class="item-card__title">{{ __("json.Quantity") }}</h4>
                            <p class="item-card__text">
                                {{ item.quantity }}
                            </p>
                        </div><div class="item-card__col">
                            <h4 class="item-card__title">{{ __("json.Location") }}</h4>
                            <p class="item-card__text">
                                {{ item.location_on_board }}
                            </p>
                        </div>
                        <div class="item-card__col">
                                <h4 class="item-card__title">{{ __("json.Use") }}</h4>
                                <p class="item-card__text">
                                    {{ item.official_use }}
                                </p>
                            </div>


                </div>
            </article>
        </li>
    </ul> -->
    <div v-else>
        <div class="account-empty">
            <img class="account-empty__img" src="/assets/images/new/empty-img.svg" width="80" height="80" alt="empty">
            <p class="account-empty__text">
                {{ __('items.no_items_yet') }}
            </p>
        </div>
    </div>
</template>
<style>
.items-table {
    width: 100%;
    border-collapse: collapse;
}
.items-table thead tr {
    border: 2px solid #EAEBEF;
    background: rgb(240, 56, 51);
    color: white;
}

.items-table thead th {
    border: 0;
    list-style: none;
    background: rgb(240, 56, 51);
}

.items-table tbody tr:nth-child(2n) {
    background: #EAEBEF;
}

.button--outline-red {
    max-width: 100px;
}
</style>
<script>
import IconLoading from "../partials/IconLoading.vue";
import {useLocalTime} from "../utils/useLocalTime";

export default {
    name: "ItemList",
    props: ['master-id'],
    components: {
        IconLoading,
    },
    setup() {
        const { toLocalTime } = useLocalTime();
        return {
            toLocalTime
        }
    },
    data() {
        return {
            items: [],
            refreshList: 'false',
            itemToDelete: null,
            isLoadingData:false,
        }
    },
    mounted() {

        this.loadItems();
    },
    methods: {

        deleteItem(item) {
            this.isLoadingData = true;

            axios
                .delete("/shipments/delete-shipment-store/" + item.id)
                .then(() => {
                    this.items = this.items.filter((t) => t.id !== item.id);
                })
                .catch((err) => {
                    console.log(err);
                    alert("Something went wrong! Please, try again.");
                })
                .finally(() => {
                    this.isLoadingData = false;
                });
        },
        loadItems() {
            this.isLoadingData = true;

            axios.get('/shipments/shipment-stores/' + this.masterId).then(({data}) => {
                this.items = data;

            }).finally(() => {
                this.$nextTick(() => {
                    window.initAccordion('.accordion-vue');
                    window.initDropdown('.dropdown-vue');
                    this.isLoadingData = false;
                });
            });
        },
    },
    computed: {

    },
    expose:['loadItems']
}
</script>
